import { useMutation } from '@tanstack/react-query'

import { postSeller } from 'components/pages/sign-up/api/post-seller'
import { SignupFormValues } from 'components/pages/sign-up/types'

export function useSellerMutation(isUserAuthenticationCalloutShown: boolean) {
  return useMutation({ mutationFn: (values: SignupFormValues) => postSeller(values, isUserAuthenticationCalloutShown) })
}
